import forgotPasswordSopLoginPageImage from "../../../assets/images/forgot-password-sop/forgot-password-sop-login-page.png";
import forgotPasswordSopRequestResetImage from "../../../assets/images/forgot-password-sop/forgot-password-sop-request-reset.png";
import forgotPasswordSopResetPasswordImage from "../../../assets/images/forgot-password-sop/forgot-password-sop-reset-password.png";

import type { ForgotPasswordSopImageConfig } from "../types";

export const FORGOT_PASSWORD_SOP_IMAGES: Record<
  string,
  ForgotPasswordSopImageConfig
> = {
  "login-page": {
    src: forgotPasswordSopLoginPageImage,
    altKey: "forgot-password-sop-image-login-page-alt",
    altFallback: "Login page with email, password, and Forgot password link"
  },
  "request-reset": {
    src: forgotPasswordSopRequestResetImage,
    altKey: "forgot-password-sop-image-request-reset-alt",
    altFallback:
      "Forgot Password page with email field and Reset Password button"
  },
  "reset-password": {
    src: forgotPasswordSopResetPasswordImage,
    altKey: "forgot-password-sop-image-reset-password-alt",
    altFallback:
      "Reset Password page with OTP, new password, and confirm password fields"
  }
};
